import 'whatwg-fetch';
import { getDefaultLeadsFormData } from 'client/javascript/default_leads_form_data';
import Deferred from './deferred';
import { varsFromServer } from './client_side_injection_vars';

async function makeRequest(url, method, requestData) {
  const requestResponse = new Deferred();

  const xhr = new XMLHttpRequest();

  function resolveDeferredIfRequestIsSuccessful() {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      if (xhr.status === 200) {
        requestResponse.resolve(JSON.parse(xhr.responseText));
      } else {
        requestResponse.reject({
          status: xhr.status,
          responseText: xhr.responseText
        });
      }
    }
  }

  xhr.open(method, url);
  xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
  xhr.onreadystatechange = resolveDeferredIfRequestIsSuccessful;
  xhr.send(JSON.stringify(requestData));

  return requestResponse.promise;
}

export function submitHostEventLeadForm(leadData, leadSource) {
  const url = `${varsFromServer.apiProxyUrl}/host-event`;

  return makeSubmitLeadRequest(url, leadData, leadSource);
}

export function submitLead(leadData, leadSource) {
  const url = `${varsFromServer.apiProxyUrl}/leads`;

  return makeSubmitLeadRequest(url, leadData, leadSource);
}

export async function makeSubmitLeadRequest(url, leadData, leadSource) {
  const defaultLeadData = await getDefaultLeadsFormData(leadSource);
  const requestData = {
    ...defaultLeadData,
    ...leadData
  };

  return makeRequest(url, 'POST', requestData);
}

export async function getTimes(building, dateStr) {
  const url = `${varsFromServer.apiProxyUrl}/tours?building_id=${building.id}&date=${dateStr}`;

  const response = await fetch(url);
  const tourTimes = await response.json();

  return tourTimes.available_tour_times;
}

export async function getAvailableDateTimes() {
  const response = await fetch('/nmd_available_times');
  const availableDateTimes = await response.json();
  return availableDateTimes;
}

export async function scheduleCall(requestData) {
  const response = await fetch('/nmd_schedule_call', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(requestData)
  });
  checkStatus(response);
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}
